import pulldown from './pulldown.vue'

let Pulldown = {}

// 只有定义了 install 方法，才能使用 Vue.use() 进行引用
Pulldown.install = function (Vue) {
  // 添加实例方法 - 扩展方法
  const PulldownController = Vue.extend(pulldown)
  let instance = new PulldownController().$mount(document.createElement('div'))
  document.body.appendChild(instance.$el)
  Vue.prototype.$pulldown = function (o) {
    instance.item = o
    instance.pullBox = true
  }
}

if (typeof window !== 'undefined' && window.Vue) {
  window.Vue.use(Pulldown)
}

export default Pulldown



// WEBPACK FOOTER //
// ./src/components/base/pulldown/index.js